import { Rndm } from './Rndm.js';
import { Arry } from './Arry.js';
import { V2 } from './V2.js';
import { Rr } from './Rr.js';

const pp = 2 * Math.PI;

export interface jnts_type {
    id: string;
    type: "jnts";
    a: any;
    b: any;
    c: any;
    stiffness: number;
    ab: number;
    ab_initial: number;
    bc: number;
    bc_initial: number;
    r: number;
    r_initial: number;
    kill: () => void;
    calc: () => void;
    [key: string]: any;
}

export interface jnts_manager_type {
    list: jnts_type[];
    get: (id: string) => any | null;
    kill: (id: string) => void;
    make: (io: any) => jnts_type;
    run: () => void;
}

export function jnts_manager(iterations = 4): jnts_manager_type {

    return {
        list: [] as jnts_type[],
        get: function (id: string): any | null {
            return Arry.get.id(this.list, id);
        },
        kill: function (id: string): void {
            const joint = Arry.get.id(this.list, id);
            if (joint) joint.kill();
        },
        make: function (io: any): jnts_type {

            const l: jnts_type = {
                ...io,
                type: "jnts",
                id: io.id || Rndm.id(),
                stiffness: io.stiffness || 0.01,
                ab: (typeof io.ab === "number") ? io.ab : V2.get.distance(io.a.pos, io.b.pos),
                ab_initial: 0,
                bc: (typeof io.bc === "number") ? io.bc : V2.get.distance(io.b.pos, io.c.pos),
                bc_initial: 0,
                r: (typeof io.r === "number") ? io.r : Rr.from.v(io.a.pos, io.b.pos, io.c.pos) / pp,
                r_initial: 0,
                leverage: io.leverage !== false,
                kill: () => Arry.remove.id(this.list, l.id),
                calc: function () {

                    const rad = Rr.from.v(l.a.pos, l.b.pos, l.c.pos);
                    const radDifference = Rr.get.shortest_difference(rad, l.r * pp) / 2;

                    const leverBC = l.leverage ? V2.get.distance(l.a.pos, l.b.pos) * l.a.mass : l.bc;
                    const leverBA = l.leverage ? V2.get.distance(l.b.pos, l.c.pos) * l.b.mass : l.ab;

                    const vectorBC = V2.get.direction(l.b.pos, l.c.pos);
                    V2.flip_x(vectorBC);
                    V2.scale(vectorBC, radDifference * l.stiffness * leverBC);
                    V2.sub(l.c.dif, vectorBC);
                    V2.add(l.b.dif, vectorBC);

                    const vectorBA = V2.get.direction(l.b.pos, l.a.pos);
                    V2.flip_x(vectorBA);
                    V2.scale(vectorBA, radDifference * l.stiffness * leverBA);
                    V2.add(l.a.dif, vectorBA);
                    V2.sub(l.b.dif, vectorBA);
                }
            };

            l.r_initial = l.r;
            l.ab_initial = l.ab;
            l.bc_initial = l.bc;

            this.list.push(l);
            return l;
        },
        run: function (): void {
            for (let i = 0; i < iterations; i++) {
                for (const l of this.list) l.calc();
            }
        }
    };
}
